import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { Heading } from "components/Heading";
import Implementation from "../tabs/Implementation";
import useMcapFilters from "../useMcapFilters";
import typography from "../typography";

export default function ImplementationScreen() {
  const { filters, renderFilterBar } = useMcapFilters();

  return (
    <div className="page-content">
      <Helmet>
        <title>{typography.TAB_IMPLEMENTATION} · MCAP</title>
      </Helmet>
      <Container fluid className="mcap-hub">
        <Heading heading={typography.TAB_IMPLEMENTATION} />
        <Implementation filters={filters} filterBar={renderFilterBar(null)} />
      </Container>
    </div>
  );
}
